<template>
  <b-row :class="$style.crossPlatformBanner">
    <div :class="$style.bannerWrapper">
      <div :class="$style.cpDOCContainer">
        <a
          :href="linkToDOC()"
          :class="$style.platformLink"
          target="_blank"
        >
          <img
            src="@/assets/images/cross-platform-doc.png"
            :class="$style.crossPlatformDOC"
            alt="Dine On Campus logo"
          />
        </a>
      </div>
      <div
        v-if="shopClosed"
        :class="$style.cpSOCContainerKo"
      >
        <img
          src="@/assets/images/cross-platform-soc-ko.png"
          :class="$style.crossPlatformSOC"
          alt="Shop On Campus logo"
        />
      </div>
      <div
        v-else
        :class="$style.cpSOCContainer"
      >
        <img
          src="@/assets/images/cross-platform-soc.png"
          :class="$style.crossPlatformSOC"
          alt="Shop On Campus logo"
        />
      </div>
    </div>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    slug: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      shopClosed: 'sites/getShopClosed',
    }),
  },

  methods: {
    linkToDOC() {
      // Production
      let domain = 'https://dineoncampus.com'
      // Development
      if (window.location.hostname === 'localhost') {
        domain = 'http://localhost:8080'
      }
      // Staging
      if (window.location.hostname === 'qa.shoponcampus.com') {
        domain = 'https://narwhal.dineoncampus.com'
      }
      return `${domain}/${this.slug}`
    },
  },
}
</script>

<style lang="scss" module>
@import url('https://fonts.googleapis.com/css?family=Covered+By+Your+Grace|Just+Another+Hand&display=swap');

.bannerWrapper {
  width: 100%;
}
.cpDOCContainer {
  display: inline-block;
  padding: 4px 12px;
}
.cpSOCContainer {
  display: inline-block;
  height: 40px;
  padding: 4px 12px;
  background: rgba(255, 255, 255, 1);
}
.cpSOCContainerKo {
  display: inline-block;
  height: 40px;
  padding: 4px 12px;
  background: rgba(230, 4, 106);
}
.crossPlatformBanner {
  height: 40px;
  padding: none !important;
  color: rgb(0, 0, 0) !important;
  background: rgb(240, 240, 240) !important;
}
.crossPlatformDOC {
  position: relative;
  top: 2px;
  height: 20px;
  opacity: 0.5;
  image-rendering: -webkit-optimize-contrast;
}
.crossPlatformSOC {
  position: relative;
  top: 6px;
  height: 20px;
  image-rendering: -webkit-optimize-contrast;
}
</style>
